import { UserPermissions } from '@centecomm/portal-service';
import { FeatureConfiguration } from 'Core/Types/FeatureConfiguration';
import SalesNavigationIcon from 'Icons/NavigationItem/Sales';
import React from 'react';
import { LoadingContent } from 'Shared/PageElements';
import { LaunchDarklyFlags } from 'utils/Hooks/LaunchDarkly/launchDarklyFlags';

const LazySalesSettingsPage = React.lazy(() => import('./Pages'));

const salesSettingsConfiguration: FeatureConfiguration = {
    name: 'administrationFeature:system.sales.title',
    navigationItem: {
        route: {
            text: 'administrationFeature:sidebar.system.sales.title',
            url: '/sales-settings',
            Icon: SalesNavigationIcon,
            ownerOperatorRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazySalesSettingsPage />
                </React.Suspense>
            ),
            tenantRoot: null,
        },
        isGloballyAccessible: false,
        permissions: [UserPermissions.ManageAdminConfig],
    },
    disableFeature: [],
    // Standalone item only appears when neither grouping surface is on
    visibilityRule: {
        [LaunchDarklyFlags.ComplianceHub]: { $ne: true },
        [LaunchDarklyFlags.ComplianceBuilder]: { $ne: true },
    },
};

export default salesSettingsConfiguration;
